import { familyData } from '../lib/data';
import styles from './Family.module.scss';

const Family = () => {

    return ( 
        <section >
            <div className = {styles.container}> 
                {familyData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="семейные фото Ставрополь"/>
                    </div>
                ))}
            </div>
        </section>
    );
}
export default Family;